// import { google } from '@agm/core/services/google-maps-types';
import {
  Directive,
  ElementRef,
  EventEmitter,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
// import google from ""
@Directive({
  selector: '[smLocationAutocomplete]',
})
export class LocationAutocompleteDirective {
  @Output('smLocationAutocomplete') googlePlaceDetails: EventEmitter<{
    place: any;
  }> = new EventEmitter<{ place: any }>();
  private _placeChangeEventListener: any;
  private _googleModule: any;
  constructor(
    private _elementRef: ElementRef<HTMLInputElement>,
    private _zoneRef: NgZone
  ) {}
  ngOnInit(): void {
    const win = window as any;
    this._googleModule = win.google;
    let autoComplete = new this._googleModule.maps.places.Autocomplete(
      this._elementRef.nativeElement,
      {
        types: ['geocode', 'establishment'],
        // componentRestrictions: { country: ['in'] },
      }
    );
    let channaiBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(12.997222, 80.256944),
      new google.maps.LatLng(13.086111, 77.711895)
    );
    autoComplete.setFields(['address_component']);
    autoComplete.setBounds(channaiBounds);

    this._placeChangeEventListener = autoComplete.addListener(
      'place_changed',
      () => {
        console.log('On place changed', autoComplete.getPlace());
        const place = autoComplete.getPlace();
        this._zoneRef.run(() => {
          this.googlePlaceDetails.next({ place });
        });
      }
    );
  }

  ngOnDestroy(): void {
    this._googleModule.maps.event.removeListener(
      this._placeChangeEventListener
    );
  }
}

// administrative_area_level_1 = state
// locality = city
// country = country
